import { render, staticRenderFns } from "./Pricer.vue?vue&type=template&id=7f1d32d6&"
import script from "./Pricer.vue?vue&type=script&lang=js&"
export * from "./Pricer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports